import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const StyledTitle = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.overview.title
})`
  display: flex;
  align-items: center;
  font-size: ${sys.typescale[14].size};
  font-weight: ${sys.fontWeight.regular};
  line-height: ${sys.typescale[14].lineHeight};
  color: ${({ mode }: { mode: Theme }) => sys[mode].text.primary};
  /* line-clamp */
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  max-height: 42px;
  overflow: hidden;
`

export default StyledTitle
